import React from 'react';
import { useRef, useEffect } from "react";


const ShadowWrapper = ({ content }) => {
    const ref = useRef(null);

    useEffect(() => {
        if (ref.current) {
            // Create Shadow DOM
            const shadow = ref.current.attachShadow({ mode: "open" });

            // Create a wrapper div and set its content
            const wrapper = document.createElement("div");
            wrapper.innerHTML = content; // Retains existing inline styles

            // Optional: Add a default style to ensure theme doesn't override anything
            const style = document.createElement("style");



            shadow.appendChild(style);
            shadow.appendChild(wrapper);
        }
    }, [content]);

    return <div ref={ref}></div>;
};

export default ShadowWrapper;
